import React, { useEffect } from "react";
import { Modal, InputNumber, Form } from "antd";
import {
  RADIUS_DEFAULT_METERS,
  RADIUS_MIN_METERS,
  RADIUS_MAX_METERS,
  RADIUS_STEP_METERS,
} from "../utils/stationUtils";

const ProtectionZoneRadiusModal = ({
  open,
  station,
  onClose,
  onConfirm,
  confirming,
}) => {
  const [form] = Form.useForm();

  const currentRadius =
    station?.radius_meters != null && station.radius_meters > 0
      ? Number(station.radius_meters)
      : null;

  useEffect(() => {
    if (open && station) {
      const initial =
        currentRadius != null ? currentRadius : RADIUS_DEFAULT_METERS;
      form.setFieldsValue({ radius_meters: initial });
    }
  }, [open, station, currentRadius, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const radius = values.radius_meters;
      await onConfirm(station.id, radius);
      form.resetFields();
      onClose();
    } catch (_) {
      // Validation failed or onConfirm threw; keep modal open
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="防護區半徑設定"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="確定"
      cancelText="取消"
      confirmLoading={confirming}
      destroyOnClose
      width={360}
    >
      {station && (
        <Form form={form} layout="vertical">
          <Form.Item
            name="radius_meters"
            label="防護區半徑 (m)"
            rules={[
              { required: true, message: "請輸入半徑" },
              {
                type: "number",
                min: RADIUS_MIN_METERS,
                max: RADIUS_MAX_METERS,
                message: `半徑請介於 ${RADIUS_MIN_METERS} ~ ${RADIUS_MAX_METERS} m`,
              },
            ]}
          >
            <InputNumber
              min={RADIUS_MIN_METERS}
              max={RADIUS_MAX_METERS}
              step={RADIUS_STEP_METERS}
              style={{ width: "100%" }}
              addonAfter="m"
            />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default ProtectionZoneRadiusModal;
